import { apiClient as api } from "./httpClient";

// Assistente do prontuário (item 206): explorador de pacientes do profissional e as sessões de cada um.
// As mensagens vão por aiChatService.send com o patientId.

export interface PatientAssistantPatient {
  id: string;
  name: string;
  birthDate: string | null;
  hasPhoto: boolean;
  pendingEvolutions: number;
  hasActiveSession: boolean;
  lastSessionAt: string | null;
}

export interface PatientAssistantData {
  /** Nulo = assistente indisponível; `unavailable` diz o porquê. */
  agentId: string | null;
  agentName: string | null;
  unavailable: string | null;
  patients: PatientAssistantPatient[];
  /** Modo conversa ligado pela clínica (D-OP-34); ainda depende da voz de pé no ambiente. */
  speechReply?: boolean;
}

export interface PatientAssistantSession {
  id: string;
  title: string | null;
  updatedAt: string;
  /** Dá para continuar (não encerrada e sem 36 h de silêncio); senão, só leitura. */
  active: boolean;
}

export const patientAssistantService = {
  /** Sem `search`: pacientes com sessão nos últimos 90 dias. Com `search` (3+ letras): os demais acessíveis. */
  get: async (search?: string): Promise<PatientAssistantData> => {
    const response = await api.get("/patient-assistant", { params: search ? { search } : undefined });
    return response.data;
  },

  sessions: async (patientId: string): Promise<PatientAssistantSession[]> => {
    const response = await api.get(`/patient-assistant/patients/${encodeURIComponent(patientId)}/sessions`);
    return response.data;
  },

  /** Encerra a sessão ao fechar a aba: a conversa fica só de leitura no Histórico. */
  endSession: async (conversationId: string): Promise<void> => {
    await api.post(`/patient-assistant/sessions/${encodeURIComponent(conversationId)}/end`);
  },
};
